import { Button, Divider, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useEffect } from 'react';
import CustomInput from '../../Form/CustomInput';



const EditBio = ({profile, onCompleted, isMobile}) => {

    const [data, setData] = useState({
        bio: '',
        location: '',
        website: ''
    });

    const [modifiedProfile, setModifiedProfile] = useState(profile); 
    const stage = 2; 

    useEffect(()=>{

        if(profile){

            setData({
                bio: profile.bio || '',
                location: profile.location || '',
                website: profile.website || ''
            });

        }
        

    }, []);

    const onSubmit = ()=>{


        //append values to profile
        if(profile){

            console.log('Edit Bio profile: ', profile, ' Data: ', data);

            // setModifiedProfile(prev => {

            //     return 
            // });


            if(typeof onCompleted == 'function'){

                console.log('On Complete function: ');

                onCompleted({
                    ...modifiedProfile,
                    ...data
                }, stage);

            }

        }
    }

    return (
        <Box
            sx={{
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: '400px',
                textAlign: 'center'
            }}
        >

            <Typography variant='h5' sx={{marginBottom: '20px'}}>
                Tell us something about yourself
            </Typography>

            {
                !isMobile &&
                <Divider sx={{width: '100%', marginBottom: '30px'}}/>
            }
            

            <CustomInput name="description" 
                variant='standard' 
                label="Describe yourself" 
                placeholder={'Will you pass the vibe check?'}
                required={true}
                fullWidth 
                multiline={true}
                value={data.bio}
                handleChange={(e)=>setData({
                    ...data,
                    bio: e.target.value
                })}
            />

            <CustomInput name="location" 
                variant='standard' 
                label="Where are you located?" 
                placeholder={'Sweet home Alabama'}
                fullWidth 
                value={data.location}
                handleChange={(e)=>setData({
                    ...data,
                    location: e.target.value
                })}
            />

            <CustomInput name="website" 
                variant='standard' 
                label="Your website" 
                placeholder={'Free advertisement'}
                fullWidth 
                value={data.website}
                onChange={(e)=>setData({
                    ...data,
                    website: e.target.value
                })}
            />

            <Button variant='main' sx={{marginTop: '20px'}} onClick={onSubmit}>
                Next
            </Button>

        </Box>
    );
}


export default EditBio; 